import { useState, useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { jwtDecode } from "jwt-decode";

export function useDecodedToken() {
  const { getToken } = useAuth();
  const [token, setToken] = useState(null);
  const [decoded, setDecoded] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchToken = async () => {
      try {
        const rawToken = await getToken();
        if (!rawToken) throw new Error("No token returned from Clerk");

        if (isMounted) {
          setToken(rawToken);
          setDecoded(jwtDecode(rawToken));
        }
      } catch (err) {
        if (isMounted) {
          setError(err);
        }
      }
    };

    fetchToken();

    return () => {
      isMounted = false;
    };
  }, [getToken]);

  return { token, decoded, error };
}
